import { buildIdentifierFieldValue } from "@repo/components/src/forms/identifier/logic";
import type { TaxProfileFragmentFragment } from "@repo/graphql/documents/fiscal/fragment.generated";
import type { TaxProfileFormValues } from "./types";

/** What the form prefills from; a `TaxProfileFragment` satisfies it. */
type SavedTaxProfile = Pick<
  TaxProfileFragmentFragment,
  | "taxId"
  | "legalName"
  | "businessActivity"
  | "email"
  | "addressLine"
  | "isLargeTaxpayer"
  | "isMunicipalWithholdingAgent"
> & {
  regimeOption: Pick<
    NonNullable<TaxProfileFragmentFragment["regimeOption"]>,
    "code"
  > | null;
};

export type TaxProfileDefaults = {
  legalName: string;
  addressLine?: string;
  taxId?: string;
};

/** The form values for a saved profile; what it lacks falls back to `defaults`. */
export const buildDefaultValues = (
  initial: SavedTaxProfile | null | undefined,
  defaults: TaxProfileDefaults,
): TaxProfileFormValues => ({
  taxId: buildIdentifierFieldValue(initial?.taxId, defaults.taxId),
  taxRegime: initial?.regimeOption?.code,
  legalName: initial?.legalName || defaults.legalName,
  businessActivity: initial?.businessActivity ?? "",
  email: initial?.email ?? "",
  addressLine: initial?.addressLine || defaults.addressLine || "",
  isLargeTaxpayer: initial?.isLargeTaxpayer ?? false,
  isMunicipalWithholdingAgent: initial?.isMunicipalWithholdingAgent ?? false,
  acknowledged: false,
});
